import { CostCenterModel } from "../archive/cost-center.model";

export class DevolutionProjectionModel {
    devolutionProjectionId: number = 0;
    branchId: number = 0;
    costCenterId: number = 0;
    costCenter: CostCenterModel = new CostCenterModel();
    dateDevolutionProjection: Date = new Date();
    createDate: Date = new Date();
    userNameCreate: string = "";
    updateDate: Date | null = null;
    userNameUpdate: string | null = null;
}